import {addDays, startOfDay, format, parseISO} from 'date-fns';
import {formatInTimeZone} from 'date-fns-tz';
import {TIMEZONE} from '#shared/constants';

export function getTomorrowStartDate() {
	return startOfDay(addDays(new Date(), 1));
}

export function fetchTodayOrEarlierFilterDate() {
	return format(getTomorrowStartDate(), 'yyyy-MM-dd HH:mm');
}

/**
 * Formats an API date (ISO string) in the Prague timezone, so SSR (UTC) and the browser render the same text.
 */
export function formatPragueDate(date: string, formatStr: string): string {
	return formatInTimeZone(parseISO(date), TIMEZONE, formatStr);
}
